import { Button, Stack, TextField, Typography } from "@mui/material";

import { useAtom } from "jotai";

import { newReferenceMeasurementValueAtom } from "store/atoms/newReferenceMeasurementValue";
import { referenceMeasurementInputValueModalStateAtom } from "store/atoms/referenceMeasurementInputValueModalState";

import { measurementModalContainer, styles } from "./style";

const ReferenceMeasurementValueInputModal = () => {
  const [
    referenceMeasurementInputValueModalState,
    setReferenceMeasurementInputValueModalState,
  ] = useAtom(referenceMeasurementInputValueModalStateAtom);

  const [newReferenceMeasurementValue, setNewReferenceMeasurementValue] =
    useAtom(newReferenceMeasurementValueAtom);

  const handleCancel = () => {
    setReferenceMeasurementInputValueModalState("cancelled");
  };
  const handleConfirm = () => {
    setReferenceMeasurementInputValueModalState("confirmed");
  };

  return (
    <Stack
      sx={measurementModalContainer(
        referenceMeasurementInputValueModalState !== "closed"
      )}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "0.8rem",
              sm: "1rem",
            },
          }}
        >
          Enter measured distance for calibration (m)
        </Typography>
        <TextField
          id="calibration"
          label="Enter Measurement"
          variant="outlined"
          autoFocus
          margin="dense"
          name="calibration"
          type="number"
          fullWidth
          size="small"
          value={newReferenceMeasurementValue || ""}
          onChange={(e) =>
            setNewReferenceMeasurementValue(parseFloat(e.target.value))
          }
          InputProps={{ sx: styles.textField__input }}
          sx={styles.textField}
        />
      </Stack>
      <Stack sx={styles.buttonWrapper}>
        <Button
          variant="outlined"
          color="error"
          sx={{ borderRadius: 10 }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ borderRadius: 10 }}
          onClick={handleConfirm}
        >
          Submit
        </Button>
      </Stack>
    </Stack>
  );
};

export default ReferenceMeasurementValueInputModal;
